<template>
  <div>
    <div class="row" style="height: 60px"></div>
    <div class="row titleRow">
      <div class="col">
        <h1>{{$t('customerDatas.title')}}</h1>
      </div>
    </div>
    <div class="row ">
      <div class="col">
        <div class="row">
          <div class="col">
            <form class="needs-validation" accept-charset="utf-8" novalidate>
              <div class="form-row">
                <div class="form-group col-md-4">
                  <label>{{$t('customerDatas.gender')}}</label>
                  <select v-model="gender" class="form-control filledForm">
                    <option value="?">{{$t('customerDatas.gender')}}</option>
                    <option value="F">{{$t('customerDatas.female')}}</option>
                    <option value="H">{{$t('customerDatas.male')}}</option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('customerDatas.lastname')}} <span class="text-danger">*</span></label>
                  <input type="text" v-model="lastname"
                         :class="'form-control ' + ((lastname !== '') ? 'filledForm' : '')">
                  <div class="invalid-feedback">
                    {{$t('customerDatas.formValidation.lastname')}}
                  </div>
                </div>
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('customerDatas.firstname')}} <span class="text-danger">*</span></label>
                  <input type="text" v-model="firstname"
                         :class="'form-control ' + ((firstname !== '') ? 'filledForm' : '')">
                  <div class="invalid-feedback">
                    {{$t('customerDatas.formValidation.firstname')}}
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('customerDatas.phone')}} <span class="text-danger">*</span></label>
                  <input type="tel"
                         pattern="^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$"
                         v-model="phone"
                         :class="'form-control ' + ((phone !== '') ? 'filledForm' : '')">
                  <div class="invalid-feedback">
                    {{$t('customerDatas.formValidation.phone')}}
                  </div>
                </div>
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('customerDatas.mail')}} <span class="text-danger">*</span></label>
                  <input type="email"
                         pattern='^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
                         v-model="email" :class="'form-control ' + ((email !== '') ? 'filledForm' : '')">
                  <div class="invalid-feedback">
                    {{$t('customerDatas.formValidation.mail')}}
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('customerDatas.freqClub.activity')}}</label>
                  <input v-model="activity" type="text"
                         :class="'form-control ' + ((activity !== '') ? 'filledForm' : '')">
                </div>
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('customerDatas.freqClub.question')}}</label>
                  <input v-model="clubName" type="text"
                         :class="'form-control ' + ((clubName !== '') ? 'filledForm' : '')">
                </div>
              </div>
              <h1>{{$t('customerDatas.subtitleSponsor')}}</h1>
              <div class="form-row">
                <div class="form-group col-md-4">
                  <label>{{$t('customerDatas.gender')}}</label>
                  <select v-model="sponsorGender" class="form-control filledForm">
                    <option value="?">{{$t('customerDatas.gender')}}</option>
                    <option value="F">{{$t('customerDatas.female')}}</option>
                    <option value="H">{{$t('customerDatas.male')}}</option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label>{{$t('customerDatas.lastname') + ' ' + $t('customerDatas.member')}}</label>
                  <input v-model="sponsorLastname" type="text"
                         :class="'form-control ' + ((sponsorLastname !== '') ? 'filledForm' : '')">
                </div>
                <div class="form-group col-md-4">
                  <label>{{$t('customerDatas.firstname') + ' ' + $t('customerDatas.member')}}</label>
                  <input v-model="sponsorFirstname" type="text"
                         :class="'form-control ' + ((sponsorFirstname !== '') ? 'filledForm' : '')">
                </div>
              </div>
              <div v-show="$store.state.config.activeSurprise" class="form-row">
                <div class="form-group col-md-10 verticalCenter">
                  <p style="display: contents;text-align: left"><em>{{$t('customerDatas.surprise')}}</em></p>
                </div>
                <div class="form-group col-md-2">
                  <label class="switch">
                    <input v-model="surprise" type="checkbox">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col overFooter">
        <button type="submit" class="btn btn-primary bg-color alignRight" @click="saveData()">{{$t('general.start')}}
        </button>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'customer-datas',
  data () {
    return {
      firstname: '',
      lastname: '',
      phone: '',
      email: '',
      gender: '?',
      sponsorGender: '?',
      sponsorLastname: '',
      sponsorFirstname: '',
      clubName: '',
      activity: '',
      surprise: false
    };
  },
  updated: function () {
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {
      layout: 'CustomerDatas',
      isAuthorized: true,
      data: this.dataTosave
    });
  },
  mounted: function () {
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {
      layout: 'CustomerDatas',
      isAuthorized: true,
      data: this.dataTosave
    });
  },
  methods: {
    saveData: function ($event) {
      this.$store.dispatch('form/FORM_NEXTLAYOUT', this.dataTosave);
    },
    validateEmail: function (email) {
      /* eslint-disable no-useless-escape */
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    validatePhone: function (tel) {
      /* eslint-disable no-useless-escape */
      var re = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;
      return re.test(String(tel));
    }
  },
  computed: {
    dataTosave: function () {
      return {
        userInfos: {
          firstname: this.firstname,
          lastname: this.lastname,
          phone: this.phone,
          email: this.email,
          gender: this.gender,
          sponsorGender: this.sponsorGender,
          sponsorLastname: this.sponsorLastname,
          sponsorFirstname: this.sponsorFirstname,
          surprise: this.surprise,
          clubName: this.clubName,
          activity: this.activity
        }
      };
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/CustomerDatas.vue